import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationAlertComponent } from './notification-alert/notification-alert.component';
import { NotificationElement } from './notification.model';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class NotificationAlertService {
  private readonly _onNewNotificationSubject$ = new Subject<any>();
  public onNewNotificationSubject$: Observable<any> =
    this._onNewNotificationSubject$.asObservable();

  constructor(private readonly dialog: MatDialog) {}

  test(type: string = 'ALERT', metadata: any = {}) {
    this.showNotification({
      _id: '1',
      title: 'Welcome to the Notification System test',
      body: 'This is a sample notification to demonstrate the notification system. Here is some additional text to test the width of the notification dialog.',
      scope_type: 'APP',
      source_type: type,
      metadata: metadata,
      created_at: new Date().toISOString(),
      expires_at: new Date(Date.now() + 60000).toISOString(),
      recipient: { user_id: 'user123', read_at: '' },
      displayDate: new Date().toLocaleString(),
    });
  }

  updateHeaderNotificationIcon(showNotification: boolean = true) {
    this._onNewNotificationSubject$.next(showNotification);
  }

  showNotification(notification: NotificationElement) {
    this.dialog.open(NotificationAlertComponent, {
      data: notification,
      panelClass: 'custom-notification-dialog',
      backdropClass: 'notification-backdrop',
      hasBackdrop: false,
      autoFocus: false,
      position: { bottom: '180px', left: '-20px' },
      disableClose: false,
    });
  }
}
